<template>
  <header-layout></header-layout>
  <div>
    <div class="fullpage-container video-bg page-padding slogen">
      <div class="content-box">
        <div class="slogen-box">
          <span class="slogen-title">MasterGo</span>
          <div class="subtitle">面向团队的专业 UI/UX 设计工具</div>
          <p>多人同时编辑、随时在线评审、设计一键交付，让想法更快实现</p>
          <div class="input-box">
            <input type="number" placeholder="输入手机号立即开始" />
            <button class="btn btn-primary btn-freeuse pointer">免费使用</button>
          </div>
        </div>
      </div>
      <div class="image-box">
        <div class="constitute-app-image">
          <img src="@/assets/image/tab-bar.png" />
          <img src="@/assets/image/canvas1.jpg" />
        </div>
      </div>
    </div>
    <div class="fullpage-container">
      <div class="image-box">
        <video src="@/assets/media/interface.mp4" autoplay loop muted playsinline></video>
      </div>
      <div class="content-box">
        <div class="text-box">
          <span class="title">专业、智能的界面设计，让想法轻松呈现</span>
          <p>
            专业的界面设计，满足所有创意需求。自动布局、素材填充等智能功能，让设计师有更多时间捕捉灵感。
          </p>
        </div>
      </div>
    </div>
    <div class="fullpage-container">
      <div class="content-box">
        <div class="text-box">
          <span class="title">交互原型，快速还原产品真实体验</span>
          <p>
            连接界面、设置交互事件，快速模拟产品使用流程。还有智能动画功能，创建原型从未如此简单。
          </p>
        </div>
      </div>
      <div class="image-box">
        <video src="@/assets/media/proto.mp4" autoplay loop muted playsinline></video>
      </div>
    </div>
    <div class="fullpage-container">
      <div class="image-box">
        <video src="@/assets/media/sys.mp4" autoplay loop muted playsinline></video>
      </div>
      <div class="content-box">
        <div class="text-box">
          <span class="title">设计系统，高效管理资源，规范全局设计</span>
          <p>
            设计资源高效管理，设计组件一键复用，实现一处修改全局同步。还有颜色和文本样式，轻松规范全局设计。
          </p>
        </div>
      </div>
    </div>
    <div class="fullpage-container">
      <div class="content-box">
        <div class="text-box">
          <span class="title">随时随地团队协作，团队能效超乎想象</span>
          <p>
            只需一个链接，即可让设计师一起创作，产品经理在线评审，工程师查看代码。团队成员汇聚一处，团队协作更轻松。
          </p>
        </div>
      </div>
      <div class="image-box">
        <video src="@/assets/media/cooperation.mp4" autoplay loop muted playsinline></video>
      </div>
    </div>
    <div class="fullpage-container">
      <div class="image-box">
        <video src="@/assets/media/deliver.mp4" autoplay loop muted playsinline></video>
      </div>
      <div class="content-box">
        <div class="text-box">
          <span class="title">设计交付，实时更新让想法更快变成现实</span>
          <p>
            设计文件云端存储，实时更新。工程师可以随时查看标注、获取代码、下载切图。设计自动交付，研发轻松高效。
          </p>
        </div>
      </div>
    </div>
    <div class="fullpage-container" style="background-image: linear-gradient(to bottom right, #accbee, #e7f0fd);">
      <div class="content-box">
        <div class="text-box">
          <span class="title">面向团队的专业 UI/UX 设计工具</span>
          <p>在同一个地方，构思、设计、协作， 让你和团队更加高效。</p>
          <p>
            现已全面适配暗黑模式，将你的鼠标移动到上面立即预览。
          </p>
        </div>
      </div>
      <div class="image-box light-dark-box">
        <light-dark class="light-dark"></light-dark>
      </div>
    </div>
  </div>
  <footer-layout></footer-layout>
</template>

<script>
import LightDark from '@/components/lightDark.vue';
import FooterLayout from './layout/footerLayout.vue';
import headerLayout from "./layout/headerLayout.vue";
export default {
  components: { headerLayout, FooterLayout, LightDark },
};
</script>

<style scoped>
.fullpage-container {
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100%;
  padding: 0 5%;
  position: relative;
}

.fullpage-container::after {
  content: '';
  position: absolute;
  height: 1px;
  background: #ddd;
  left: 0;
  right: 0;
  bottom: 0;
}

.fullpage-container.slogen {
  padding: 0;
}

.fullpage-container.video-bg {
  background: -webkit-gradient(linear,
      left top,
      right top,
      color-stop(40%, #fff),
      color-stop(50%, #f6f6fa));
  background: linear-gradient(90deg, #fff 40%, #f6f6fa 50%);
}

.content-box,
.image-box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 2.5%;
  padding-right: 5%;
}

.content-box {
  flex: 1 1;
  padding: 0 5%;
}

.image-box {
  flex: 2 1;
}

.slogen .content-box,
.slogen .image-box {
  height: 100%;
  flex: 1 1;
  display: flex;
  align-items: center;
  padding-left: 2.5%;
  padding-right: 5%;
}

.image-box>.constitute-app-image {
  border-radius: 10px;
  box-shadow: 0 10px 30px #0003;
  overflow: hidden;
  background-color: #fff;
  max-width: 600px;
}


.slogen-box {
  width: 100%;
  max-width: 320px;
  margin-left: 20%;
  position: relative;
  text-align: left;
}

.slogen-box .subtitle {
  font-size: 20px;
  /* font-weight: bold; */
  margin-top: 8px;
  color: #2e3a59
}

.slogen-box .slogen-title {
  font-weight: 900;
  line-height: 72px;
  font-size: 64px;
  color: #2e3a59;
  font-family: GlowSansSC-ExtendedHeavy;
}

.slogen-box>p {
  font-size: 14px;
  color: #323c55;
  text-align: justify;
  line-height: 24px;
  margin-top: 20px;
  font-family: PingFang SC;
}

.image-box img {
  width: 100%;
}

.image-box video {
  width: 80%;
  border-radius: 16px;
}

.input-box {
  position: relative;
  margin-top: 1.5rem;
}

.input-box input {
  display: block;
  padding: 1rem 1.5rem;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid gray;
  border-radius: 10px;
  font-size: 14px;
  color: #000;
  outline: none;
  -webkit-appearance: none;
}

.input-box input:focus {
  border-color: #1b9aee !important;
}

.btn-freeuse {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  line-height: 100%;
  border-radius: 10px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.content-box .text-box {
  text-align: left;
}

.content-box .text-box .subtitle {
  font-size: 20px;
  margin-top: 8px;
  color: #2e3a59
}

.content-box .text-box .title {
  font-size: 32px;
  line-height: 36px;
  display: inline-block;
  margin-bottom: 1rem;
  font-weight: 900;
  color: #2e3a59;
  font-family: GlowSansSC-ExtendedHeavy;
}

.content-box .text-box p {
  font-size: 16px;
  color: #808897;
  text-align: justify;
  line-height: 24px;
  margin-top: 20px;
  font-family: PingFang SC;
}

.light-dark {
  box-shadow: 0 10px 30px #0005;
  border-radius: 10px;
  overflow: hidden;
}

.image-box.light-dark-box {
  width: 100%;
  padding-left: 5%;
  position: relative;
  right: -5%;
}


@media (max-width: 900px) {

  .slogen-box {
    margin-left: 15%;
  }
}

@media (max-width: 765px) {
  .fullpage-container {
    flex-direction: column;
    height: unset;
    padding: 20% 0;
  }

  .fullpage-container.slogen {
    padding: 0;
    margin-bottom: 5%;
  }

.fullpage-container.slogen {
  padding-top: 10%;
}
  .content-box {
    padding: 0;
  }

  .content-box>.text-box {
    padding: 2.5% 10%;
  }

  .content-box>.slogen-box {
    padding: 15% 0;
  }

  .content-box>.slogen-box>.slogen-title {
    font-size: 45px;
  }

  .content-box>.slogen-box>.slogen-title {
    font-size: 45px;
  }

  .slogen-box {
    margin-left: 0%;
  }

  .slogen .image-box {
    padding-bottom: 5%;
    width: 80%;
  }

  .image-box.light-dark-box {
    right: unset;
  }
}
</style>